import { AnnotationEditorType } from '@denodecom/pdfjs-dist/types';
import { useSelector } from 'react-redux';
import { useMatch, useParams } from 'react-router-dom';

import routes from '@/routes';

// Editor none mode disables blocking key events
export function useSetEditorNoneMode() {
	const mode = useSelector(state => state.editor.annotationEditMode);
	const isEditor = useMatch({ path: routes.editor, end: false });

	return async function setEditorNoneMode() {
		if (!isEditor || mode === AnnotationEditorType.NONE) {
			return;
		}
		try {
			const { default: PDFViewerApplication } = await import(
				'@/pdfjsWeb/pdf_viewer_application'
			);
			PDFViewerApplication.eventBus?.dispatch('switchannotationeditormode', {
				mode: AnnotationEditorType.NONE
			});
			// eslint-disable-next-line no-empty
		} catch (error) {}
	};
}

export function useTransactionId() {
	const params = useParams();

	const recoveryTransactionId = useSelector(
		state => state.editor?.recoveryTransactionId
	);

	return recoveryTransactionId || params.id;
}
